import React from 'react';
import PropTypes from 'prop-types';

import User from './User';
import Actions from './Actions';

class Users extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            selectedUsersIds: new Set(),
            lastSelectedIndex: undefined,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.users !== this.props.users) {
            this.setState({ lastSelectedIndex: undefined });
        }
    }

    onSelect = (user, isShiftKeyPressed) => {
        const { selectedUsersIds, lastSelectedIndex } = this.state;
        const { users, actions } = this.props;
        if (actions.length === 0) {
            return;
        }
        let affectedUsersIds = new Set();
        const userIndex = users.indexOf(user);
        if (lastSelectedIndex === undefined || !isShiftKeyPressed) {
            affectedUsersIds.add(user.id);
        } else if (isShiftKeyPressed) {
            const start = Math.min(lastSelectedIndex, userIndex);
            const end = Math.max(lastSelectedIndex, userIndex);

            for (let i = start; i <= end; i += 1) {
                affectedUsersIds.add(users[i].id);
            }
        }

        const shouldRemove = selectedUsersIds.has(user.id);

        if (shouldRemove) {
            affectedUsersIds.forEach(id => selectedUsersIds.delete(id));
        } else {
            affectedUsersIds.forEach(id => selectedUsersIds.add(id));
        }

        this.setState({
            selectedUsersIds: new Set([...selectedUsersIds]),
            lastSelectedIndex: userIndex,
        });
    };

    onSelectAllClick = () => {
        const { selectedUsersIds } = this.state;
        const { users } = this.props;

        if (users.length === selectedUsersIds.size) {
            this.setState({ selectedUsersIds: new Set() });
        } else {
            this.setState({
                selectedUsersIds: new Set(users.map(user => user.id)),
            });
        }
    };

    onMultiUserAction = action => {
        this.props.onAction([...this.state.selectedUsersIds], action);
    };

    render() {
        const { users, actions, onAction, showIndividualActions } = this.props;
        const { selectedUsersIds } = this.state;

        const userList = users.map(user => (
            <User
                key={user.id}
                user={user}
                onSelect={this.onSelect}
                isSelected={selectedUsersIds.has(user.id)}
                actions={actions}
                onAction={onAction}
                showActions={showIndividualActions && !selectedUsersIds.size}
            />
        ));

        return (
            <React.Fragment>
                <Actions
                    users={users}
                    actions={actions}
                    selectedUsersIds={selectedUsersIds}
                    onAction={onAction}
                    onSelectAllClick={this.onSelectAllClick}
                />
                {userList}
            </React.Fragment>
        );
    }
}

Users.propTypes = {
    users: PropTypes.array.isRequired,
    actions: PropTypes.array,
    onAction: PropTypes.func,
    showIndividualActions: PropTypes.bool,
};

Users.defaultProps = {
    actions: [],
    onAction: undefined,
    showIndividualActions: true,
};

export default Users;



// WEBPACK FOOTER //
// ./src/components/users/Users.js